import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { threshold: { type: Number, default: 200 } }

  connect() {
    const rootMargin = `0px 0px -${this.thresholdValue}px 0px`

    this.observer = new IntersectionObserver(
      this.#handleIntersect.bind(this),
      { root: null, rootMargin, threshold: 0 }
    )

    this.observer.observe(this.element)
    this.#checkVisibility()
  }

  disconnect() {
    this.observer.disconnect()
  }

  #checkVisibility() {
    const rect = this.element.getBoundingClientRect()
    const visible = rect.top < window.innerHeight && rect.bottom > 0
    this.#toggleVisibility(visible)
  }

  #handleIntersect(entries) {
    entries.forEach(entry => {
      this.#toggleVisibility(entry.isIntersecting)
    })
  }

  #toggleVisibility(visible) {
    if (visible) this.element.dataset.visible = true
  }
}
